/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Portuguese (Brazil)
export default {
  'automation-menu.empty-state.image.alt': 'Ícone da lista de automação vazia',
  'automation-menu.empty-state.learn-more.link': 'Saiba mais sobre o acionador manual',
  'automation-menu.modal.empty.automations.admin.description':
    'Use o acionador manual para preencher um menu de seleções que qualquer pessoa ou alguém que você especificar possa aplicar como automações de um clique.',
  'automation-menu.modal.empty.automations.user.description':
    'Os administradores ainda não configuraram nenhuma automação que precise ser acionada pelo usuário.',
  'automation-menu.modal.error.description': 'Está demorando um pouco para carregar. Atualize a página.',
  'automation-menu.modal.error.image.alt': 'Ícone de erro',
  'automation-menu.modal.footer.automate-button': 'Automatizar',
  'automation-menu.modal.footer.cancel-button': 'Cancelar',
  'automation-menu.modal.footer.get-started-button': 'Criar automação',
  'automation-menu.modal.footer.ok-button': 'Ok',
  'automation-menu.modal.header.icon.label': 'Ícone de cabeçalho modal de Automação',
  'automation-menu.success-state.message': 'A automação está em andamento',
  'fabric.linking.access_exists_description': 'Solicite acesso para visualizar este conteúdo em {hostname}.',
  'fabric.linking.actions': 'Ações',
  'fabric.linking.add_account': 'Adicionar conta',
  'fabric.linking.ai_summarize': 'Resumir',
  'fabric.linking.ai_summarized': 'Resumido pelo Atlassian Intelligence',
  'fabric.linking.ai_summarized_abbreviation': 'Resumido pelo AI',
  'fabric.linking.ai_summarized_info': 'A qualidade das informações pode variar. <a>Saiba mais</a>',
  'fabric.linking.ai_summarized_info_short': 'A qualidade do conteúdo pode variar',
  'fabric.linking.ai_summarizing': 'O Atlassian Intelligence está trabalhando...',
  'fabric.linking.ai_summary_action': 'Resuma com o AI',
  'fabric.linking.ai_summary_action_description': 'Resume o conteúdo deste link com o Atlassian Intelligence.',
  'fabric.linking.ai_summary_error_acceptable_use_violation':
    'A gente não pode mostrar os resultados deste resumo, pois vão contra a <a>Política de uso aceitável da Atlassian</a>.',
  'fabric.linking.ai_summary_error_exceeding_context_length_error':
    'O Atlassian Intelligence não pode gerar um resumo para você no momento, pois há muito conteúdo para resumir.',
  'fabric.linking.ai_summary_error_generic':
    'O Atlassian Intelligence (AI) não está respondendo. Tente de novo ou <a>verifique o status do AI</a>.',
  'fabric.linking.ai_summary_error_hipaa_content_detected':
    'O Atlassian Intelligence não conseguiu processar a solicitação, pois o conteúdo contém links para conteúdo restrito da HIPAA.',
  'fabric.linking.assigned_to': 'Atribuído a {context}',
  'fabric.linking.automation-action.confluence.page.modal.description':
    'Aplique uma automação para <b>{name}</b>.{br}As seleções disponíveis são controladas pelos administradores do Confluence e do espaço.',
  'fabric.linking.automation-action.confluence.page.modal.title': 'Automações de página',
  'fabric.linking.automation-action.icon.label': 'Ícone de automação',
  'fabric.linking.automation-action.title': 'Ver regras de automação',
  'fabric.linking.automation-action.tooltip': 'Selecione uma regra de automação para ser executada',
  'fabric.linking.beta': 'Beta',
  'fabric.linking.cancel': 'Cancelar',
  'fabric.linking.cannot_connect': 'Não é possível conectar; tente de novo',
  'fabric.linking.cannot_find_link': 'Não é possível encontrar o link',
  'fabric.linking.check_this_link': 'Conferir este link',
  'fabric.linking.click_to_join': 'Entrar no {context}',
  'fabric.linking.click_to_join_description': 'Você foi aprovado, então já pode entrar no {context}.',
  'fabric.linking.close': 'Fechar',
  'fabric.linking.connect_account_description':
    'Abriremos uma nova página para ajudar você a conectar sua conta do {name}',
  'fabric.linking.connect_link_account': 'Conectar para visualizar',
  'fabric.linking.connect_link_account_card_view': 'Conectar',
  'fabric.linking.connect_link_account_card_view_description':
    'Para ver uma prévia desse link, conecte a conta {context}.',
  'fabric.linking.connect_link_account_card_view_name': 'Conectar a conta do {context}',
  'fabric.linking.connect_to': 'Conectar-se ao {name}',
  'fabric.linking.connect_unauthorised_account_action': 'Conectar ao {context}',
  'fabric.linking.connect_unauthorised_account_description':
    'Conecte a conta {context} para colaborar no trabalho em todos os produtos da Atlassian.',
  'fabric.linking.connect_unauthorised_account_description_no_provider':
    'Conecte a conta para colaborar no trabalho em todos os produtos da Atlassian.',
  'fabric.linking.continue': 'Continuar',
  'fabric.linking.copied_summary_action_description': 'Resumo copiado para a área de transferência',
  'fabric.linking.copied_url_to_clipboard': 'Copiado!',
  'fabric.linking.copy_summary_action': 'Copiar o resumo',
  'fabric.linking.copy_summary_action_description': 'Copiar o resumo',
  'fabric.linking.copy_url_to_clipboard': 'Copiar link',
  'fabric.linking.couldnt_load_link': 'Não foi possível carregar esse link por um motivo desconhecido.',
  'fabric.linking.create_on_absolute': 'Data de criação em {context}',
  'fabric.linking.create_on_relative': 'Criação: {context}',
  'fabric.linking.created_by': 'Criado por {context}',
  'fabric.linking.delete': 'Excluir',
  'fabric.linking.direct_access': 'Entrar agora',
  'fabric.linking.direct_access_description':
    'A equipe já usa o {product} para colaborar e você também pode começar agora mesmo!',
  'fabric.linking.direct_access_title': 'Entre no {product} para ver este conteúdo',
  'fabric.linking.download': 'Baixar',
  'fabric.linking.download_description': 'Baixa o arquivo para o armazenamento local',
  'fabric.linking.download_file': 'Baixar arquivo',
  'fabric.linking.edit': 'Editar',
  'fabric.linking.follow': 'Seguir',
  'fabric.linking.follow_goal': 'Seguir meta',
  'fabric.linking.follow_goal_description': 'Siga esta meta para obter notificações e atualizações',
  'fabric.linking.follow_goal_error':
    'Foi encontrado um erro ao tentar seguir a meta. Verifique a conexão ou atualize a página e tente de novo.',
  'fabric.linking.follow_project': 'Seguir projeto',
  'fabric.linking.follow_project-galaxia': 'Seguir espaço',
  'fabric.linking.follow_project_description': 'Siga para receber notificações sobre o projeto',
  'fabric.linking.follow_project_description-galaxia': 'Siga para receber notificações sobre o espaço',
  'fabric.linking.follow_project_error':
    'Foi encontrado um erro ao tentar seguir o projeto. Verifique a conexão ou atualize a página e tente de novo.',
  'fabric.linking.follow_project_error-galaxia':
    'Foi encontrado um erro ao tentar seguir o espaço. Verifique a conexão ou atualize a página e tente de novo.',
  'fabric.linking.forbidden_access': 'O acesso é proibido',
  'fabric.linking.forbidden_description': 'Fale com o administrador para solicitar acesso a {hostname}.',
  'fabric.linking.forbidden_title': 'Você não tem acesso a este conteúdo',
  'fabric.linking.generic_error_message': 'Ocorreu um erro',
  'fabric.linking.go_back': 'Voltar',
  'fabric.linking.invalid_permissions': 'Conteúdo restrito',
  'fabric.linking.invalid_permissions_description':
    'Você precisa solicitar o acesso ou tentar usar outra conta para poder visualizar.',
  'fabric.linking.join_to_view': 'Entre em {context} para ver esse item',
  'fabric.linking.join_to_view-issue-term-refresh': 'Entre em {context} para ver esse ticket',
  'fabric.linking.learn_more_about_connecting_account':
    'Saiba mais sobre como conectar a conta aos produtos Atlassian.',
  'fabric.linking.learn_more_about_smart_links': 'Saiba mais sobre os links inteligentes.',
  'fabric.linking.link_safety_warning_message':
    'O link {unsafeLinkText} acessa um site diferente, <a>link real está aqui</a>',
  'fabric.linking.loading': 'Carregando...',
  'fabric.linking.modified_on_absolute': 'Atualizado em {context}',
  'fabric.linking.modified_on_relative': 'Atualizado em {context}',
  'fabric.linking.more_actions': 'Mais ações',
  'fabric.linking.no_access_title': 'Entre no {product} para ver este conteúdo',
  'fabric.linking.not_found_description':
    'A página não existe ou pode ter sido alterada depois que esse link foi adicionado.',
  'fabric.linking.not_found_title': 'Não é possível exibir esta página {product}',
  'fabric.linking.open_issue_in_jira': 'Abrir item no Jira',
  'fabric.linking.open_issue_in_jira-issue-term-refresh': 'Abrir ticket no Jira',
  'fabric.linking.open_link_in_a_new_tab': 'Abrir link em uma nova guia',
  'fabric.linking.owned_by': 'Pertence a {context}',
  'fabric.linking.owned_by_override': 'Por {context}',
  'fabric.linking.pending_request': 'A solicitação de acesso está pendente',
  'fabric.linking.preview_close': 'Fechar pré-visualização',
  'fabric.linking.preview_description': 'Abre uma pré-visualização em tela cheia deste link',
  'fabric.linking.preview_improved': 'Abrir pré-visualização',
  'fabric.linking.preview_max_size': 'Exibir em tela cheia',
  'fabric.linking.preview_min_size': 'Fechar tela cheia',
  'fabric.linking.preview_modal': 'Abrir o modal de pré-visualização',
  'fabric.linking.preview_panel': 'Abrir o painel de pré-visualização',
  'fabric.linking.priority_blocker': 'Gravíssima',
  'fabric.linking.priority_critical': 'Crítica',
  'fabric.linking.priority_high': 'Alta',
  'fabric.linking.priority_highest': 'Mais alta',
  'fabric.linking.priority_low': 'Baixa',
  'fabric.linking.priority_lowest': 'Mais baixa',
  'fabric.linking.priority_major': 'Alta',
  'fabric.linking.priority_medium': 'Média',
  'fabric.linking.priority_minor': 'Média',
  'fabric.linking.priority_trivial': 'Trivial',
  'fabric.linking.priority_undefined': 'Indefinida',
  'fabric.linking.read_time': '{context} minutos de leitura',
  'fabric.linking.related': 'Relacionado',
  'fabric.linking.related_links_found_in': 'Encontrado em',
  'fabric.linking.related_links_includes_links_to': 'Inclui links para',
  'fabric.linking.related_links_modal_error_description':
    'Verifique sua conexão ou atualize a página para tentar de novo',
  'fabric.linking.related_links_modal_error_title': 'Ocorreu um problema ao carregar links relacionados',
  'fabric.linking.related_links_modal_title': 'Links relacionados',
  'fabric.linking.related_links_modal_unavailable_description':
    'A gente está sempre analisando e adicionando links relacionados para páginas atualizadas ou outros tipos de conteúdo',
  'fabric.linking.related_links_modal_unavailable_title': 'Não foi possível encontrar nenhum link relacionado',
  'fabric.linking.related_links_not_found': 'A gente não encontrou nenhum link para mostrar aqui.',
  'fabric.linking.related_links_view_related_links': 'Exibir links relacionados',
  'fabric.linking.related_links_view_related_urls': 'Ver links recentes',
  'fabric.linking.request_access': 'Solicitar acesso',
  'fabric.linking.request_access_description':
    'A equipe já usa o {product} para colaborar. Envie ao administrador uma solicitação de acesso.',
  'fabric.linking.request_access_pending': 'Aprovação pendente',
  'fabric.linking.request_access_pending_description':
    'A solicitação de acesso a {hostname} está aguardando aprovação do administrador.',
  'fabric.linking.request_access_pending_title': 'O acesso a {product} está pendente',
  'fabric.linking.request_access_to_view': 'Solicite acesso a {context} para ver esse item',
  'fabric.linking.request_access_to_view-issue-term-refresh': 'Solicite acesso a {context} para ver esse ticket',
  'fabric.linking.request_denied': 'A solicitação de acesso foi negada',
  'fabric.linking.request_denied_description':
    'O administrador não aprovou a solicitação para visualizar páginas {product} de {hostname}.',
  'fabric.linking.restricted_link': 'Link restrito; tente outra conta',
  'fabric.linking.retry': 'Tentar novamente',
  'fabric.linking.save': 'Salvar',
  'fabric.linking.sent_on_absolute': 'Enviado em {context}',
  'fabric.linking.sent_on_relative': 'Enviado {context}',
  'fabric.linking.srclink': 'Visualizar em',
  'fabric.linking.srclinkunknown': 'Ver o original',
  'fabric.linking.status_change_load_error': 'Não foi possível carregar os status ou as transições',
  'fabric.linking.status_change_permission_error': 'Você não tem permissão para fazer a transição desse item.',
  'fabric.linking.status_change_permission_error-issue-term-refresh':
    'Você não tem permissão para fazer a transição desse ticket.',
  'fabric.linking.status_change_update_error': 'Não foi possível atualizar o status',
  'fabric.linking.team_members_count': '{context} membros',
  'fabric.linking.try_again': 'Tentar novamente',
  'fabric.linking.try_another_account': 'Experimente uma outra conta',
  'fabric.linking.unassigned': 'Sem responsável',
  'fabric.linking.unauthorised_account_description':
    'Você está tentando visualizar um link de uma página {context} privada. Verifique o URL ou entre em contato com o proprietário da página.',
  'fabric.linking.unauthorised_account_description_no_provider':
    'Você está tentando visualizar um link de uma página privada. Verifique o URL ou entre em contato com o proprietário da página.',
  'fabric.linking.unauthorised_account_name': 'Não é possível exibir páginas privadas de {context}',
  'fabric.linking.unauthorised_account_name_no_provider': 'Não é possível exibir páginas privadas',
  'fabric.linking.unfollow': 'Deixar de seguir',
  'fabric.linking.unfollow_goal': 'Parar de seguir meta',
  'fabric.linking.unfollow_goal_description': 'Pare de seguir para não receber mais notificações sobre a meta',
  'fabric.linking.unfollow_goal_error':
    'Foi encontrado um erro ao tentar parar de seguir a meta. Verifique a conexão ou atualize a página e tente de novo.',
  'fabric.linking.unfollow_project': 'Parar de seguir projeto',
  'fabric.linking.unfollow_project-galaxia': 'Parar de seguir espaço',
  'fabric.linking.unfollow_project_description': 'Pare de seguir para não receber mais notificações sobre o projeto',
  'fabric.linking.unfollow_project_description-galaxia':
    'Pare de seguir para não receber mais notificações sobre o espaço',
  'fabric.linking.unfollow_project_error':
    'Foi encontrado um erro ao tentar para de seguir o projeto. Verifique a conexão ou atualize a página e tente de novo.',
  'fabric.linking.unfollow_project_error-galaxia':
    'Foi encontrado um erro ao tentar para de seguir o espaço. Verifique a conexão ou atualize a página e tente de novo.',
  'fabric.linking.unlink_account': 'Desvincular conta',
  'fabric.linking.updated_by': 'Modificado por {context}',
  'fabric.linking.user_attributes': '{context}',
  'fabric.linking.view': 'Visualizar',
};
